<div class="flex flex-col h-full min-h-0">

    @if(canViewOrgTab) {

    <app-tabs-panels class="tabs-header-only flex-shrink-0" [tabs]="creditTabs" [activeTabValue]="activeTab"
        (tabChanged)="onTabChange($event)" />

    @if(activeTab === CREDIT_TAB.USER) {
    <ng-container *ngTemplateOutlet="userTabContent" />
    }

    @if(activeTab === CREDIT_TAB.ORG) {
    <div class="flex flex-col gap-4 p-4 overflow-y-auto flex-1 min-h-0">
        @if(orgAnalytics()) {
        <div class="flex flex-col gap-3">
            <div class="flex items-center justify-between">
                <span class="font-bold text-base">Overview</span>
                <div class="flex items-center gap-2 flex-shrink-0 flex-wrap">

                    <app-button [label]="selectedOrgModeLabel" variant="outlined" severity="contrast"
                        icon="chevron-down" iconPosition="right" iconSource="lucide"
                        (clicked)="orgModeMenu.toggle($event)" />

                    @if(hasBillingAccess) {
                    <app-button
                        [label]="orgSelectedUser === 'All' ? 'All Users' : (selectedOrgUserOption?.label ?? 'All Users')"
                        variant="outlined" severity="contrast" icon="chevron-down" iconPosition="right"
                        iconSource="lucide" (clicked)="orgUsersMenu.toggle($event)" />
                    }
                </div>
            </div>
            <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
                @for(card of orgOverviewCards(); track card.id) {
                <ng-container *ngTemplateOutlet="overviewCard; context: { card }"></ng-container>
                }
            </div>
        </div>
        }

        <div class="flex flex-col gap-3 flex-shrink-0">
            <div class="bg-surface-0 rounded-base border shadow-md overflow-hidden">
                <div class="px-4 pt-4 pb-2 flex items-center justify-between flex-wrap gap-2">
                    <div class="flex items-center gap-4">
                        <span class="font-bold text-base">Usage Trend</span>
                        @if(trendLoading()) {
                        <app-icon type="loader" source="lucide" size="sm" class="animate-spin text-surface-400" />
                        }
                    </div>
                    <div class="flex items-center gap-3">
                        <app-select-button [options]="trendPresetOptions" [(ngModel)]="trendPresetValue"
                            (ngModelChange)="onTrendPresetChange($event)"></app-select-button>
                        <app-datepicker [(ngModel)]="trendCustomDateRange" [config]="trendDatepickerConfig"
                            (ngModelChange)="onTrendDateRangeSelect($event)"></app-datepicker>
                    </div>
                </div>
                @if(trendData().length > 0) {
                <div class="px-4 pb-4">
                    <div echarts [options]="trendChartOption()" style="height: 280px; width: 100%;"></div>
                </div>
                } @else if(!trendLoading()) {
                <div class="px-4 pb-10 pt-6 flex flex-col items-center justify-center gap-2 text-surface-400">
                    <app-icon type="bar-chart-2" source="lucide" size="lg" />
                    <span class="text-sm">No usage data for the selected period</span>
                </div>
                }
            </div>
        </div>

        @if(hasAlerts) {
        <div class="flex flex-col gap-3">
            <span class="font-bold text-base flex items-center gap-2">
                Limit Alerts
            </span>
            <app-data-table [data]="allAlertRows()" [columns]="alertColumns" [config]="alertTableConfig" [customTemplates]="alertTemplatesMap" />
        </div>
        }

    </div>
    }

    } @else {
    <ng-container *ngTemplateOutlet="userTabContent" />
    }
</div>


<app-menu #usersMenu [items]="userMenuItems" [selectedValues]="selectedUserMenuData"
    (itemSelected)="onUserSelected($event)" [search]="true" [itemTemplate]="userItemTemplate" />

<app-menu #orgModeMenu [items]="orgModeMenuItems" [selectedValues]="selectedOrgModeData"
    (itemSelected)="onOrgModeSelected($event)" />

<app-menu #orgUsersMenu [items]="orgUserMenuItems" [selectedValues]="selectedOrgUserData"
    (itemSelected)="onOrgUserSelected($event)" [search]="true" [itemTemplate]="userItemTemplate" />

<app-credits-checkout-dialog [(visible)]="checkoutDialogVisible" [checkoutItems]="checkoutItems"
    [successUrl]="checkoutSuccessUrl" [cancelUrl]="checkoutCancelUrl" [source]="CHECKOUT_SESSION_TYPE.ADD_CREDITS" />


<ng-template #userTabContent>
    <div class="flex flex-col flex-1 min-h-0">

        <div class="flex flex-wrap justify-between items-center gap-3 flex-shrink-0 px-4 py-2">
            <div class="flex gap-2 items-center flex-wrap">
                <app-button label="Get Credits" variant="filled" severity="primary"
                    (clicked)="creditsOverviewRef?.openRequestDialog()" />
                @if(canAddCredits) {
                <app-button label="Add Credits" variant="filled" severity="default"
                    (clicked)="openAddCreditsDialog()" />
                }
            </div>
            <div class="flex items-center gap-3 flex-wrap">
                @if(hasBillingAccess) {
                <div class="flex items-center gap-2 cursor-pointer border border-gray-200 rounded-base pt-1 px-1 bg-surface-0 hover:bg-surface-50 transition-colors"
                    (click)="usersMenu.toggle($event)">
                    <app-user-name-display [user]="selectedUserOption?.data" variant="avatar-name" size="sm" />
                    <app-icon type="chevron-down" source="lucide" size="sm" class="text-surface-400 pb-1" />
                </div>
                }
                <app-select-button [options]="filterOptions" [(ngModel)]="selectedFilter"
                    (ngModelChange)="onFilterChange()"></app-select-button>
            </div>
        </div>

        <div class="flex flex-col gap-4 px-4 pb-4 overflow-y-auto flex-1 min-h-0">
            <app-credits-overview #creditsOverviewRef [credits]="userCredits" [needHeader]="false" [variant]="'cards'"
                [needActionButtons]="false" [filter]="selectedFilter" />

            <div class="flex flex-col gap-2">
                <div class="flex items-center justify-between">
                    <span class="font-bold text-base">Usage Records</span>
                    <!-- Total groups comes from the API (accounts for all pages). -->
                    <span class="text-xs text-surface-400">
                        {{ totalGroups }} {{ totalGroups === 1 ? 'entry' : 'entries' }}
                        @if (totalPages > 1) {
                        &middot; page {{ currentPage }}/{{ totalPages }}
                        }
                    </span>
                </div>

                <!-- Usage accordion table — rendered through the shared DataTableComponent.
                     Accordion expand/collapse state is managed by the DataTable internally.
                     The DataTableComponent handles loading skeletons, the empty-state message,
                     and pagination — grouping/paging happens server-side, so we run the
                     paginator in "external" mode and re-fetch the requested page on change. -->
                <div class="rounded-base border overflow-hidden bg-surface-0 shadow-sm flex flex-col usage-table-wrapper">
                    <app-data-table
                        [data]="groupedRows"
                        [columns]="usageColumns"
                        [config]="usageTableConfig"
                        [customTemplates]="usageTemplatesMap"
                        [externalPagination]="true"
                        [externalFirst]="(currentPage - 1) * pageSize"
                        [externalTotalRecords]="totalGroups"
                        (pageChange)="onUsagePageChange($event)"
                        dataKey="key" />
                </div>
            </div>
        </div>

    </div>
</ng-template>

<!--
    ── Usage accordion table templates ────────────────────────────────────────
    The DataTableComponent passes these to both parent (UsageGroup) rows and,
    via config.childColumns, to child (UsageChild) rows.

    Parent context:  { $implicit: UsageGroup,  isChild: undefined }
    Child context:   { $implicit: UsageChild,  isChild: true, parent: UsageGroup }

    We use `let-isChild="isChild"` to switch rendering between the two levels.
-->

<!-- Details column: parent shows the entity title; child row leaves it blank. -->
<ng-template #usageDetailsCellRef let-row let-isChild="isChild">
    @if (!isChild) {
    <span class="text-sm font-medium leading-tight block truncate" [title]="row.title">
        {{ row.title || '—' }}
    </span>
    }
</ng-template>

<!-- Date column: parent shows date (e.g. "Jul 12, 2026"); child shows time (e.g. "3:45 PM"). -->
<ng-template #usageDateCellRef let-row let-isChild="isChild">
    @if (isChild) {
    <!-- Time of the most recent run for this child feature -->
    @if (row.lastRunAt) {
    <span class="text-xs text-surface-400">{{ row.lastRunAt | date:'h:mm a' }}</span>
    }
    } @else {
    <span class="text-xs text-surface-500">{{ row.dateStr | date:'MMM d, yyyy' }}</span>
    }
</ng-template>

<!-- Feature column: parent shows first child's feature + overflow badge; child shows its own feature name. -->
<ng-template #usageFeatureCellRef let-row let-isChild="isChild">
    @if (isChild) {
    <!-- Child: own feature label -->
    <span class="text-xs text-surface-600 leading-tight truncate block" [title]="row.feature">
        {{ row.feature || '—' }}
    </span>
    } @else {
    <!-- Parent: first child preview + optional +N overflow badge -->
    <div class="flex items-start gap-1 flex-wrap min-w-0">
        <span class="text-xs text-surface-600 truncate" [title]="row.children[0]?.feature">
            {{ row.children[0]?.feature || '—' }}
        </span>
        @if (row.children.length > 1) {
        <span class="shrink-0 text-[10px] font-medium px-1 py-0.5 rounded bg-surface-200 text-surface-500 leading-none">
            +{{ row.children.length - 1 }}
        </span>
        }
    </div>
    }
</ng-template>

<!-- Mode column: identical layout for parent and child — one chip per distinct mode. -->
<ng-template #usageModeCellRef let-row>
    <div class="flex flex-col gap-1">
        @for (mode of row.modes; track mode) {
        <span [class]="modeChipClass(mode)">
            @if (mode === 'ASK') {
            <app-icon type="zap" source="lucide" size="sm" />
            <span>Ask</span>
            } @else if (mode === 'AGENT') {
            <app-icon [type]="CREDITS_SVG.AGENT_MODE" source="svg" size="sm" />
            <span>Agent</span>
            } @else {
            <span>{{ mode }}</span>
            }
        </span>
        }
    </div>
</ng-template>

<!-- Credits column: identical layout for parent and child — credit amount aligned per mode row. -->
<ng-template #usageCreditsCellRef let-row>
    <div class="flex flex-col gap-1 items-end">
        @for (mode of row.modes; track mode) {
        <span class="text-xs font-mono text-surface-700">
            {{ row.creditsByType[mode] | number:'1.3-3' }}
        </span>
        }
    </div>
</ng-template>

<ng-template #creditsCellRef let-row="$implicit">
    <span class="text-sm text-gray-700">{{ formatCredits(row.consumedCredits) }}</span>
</ng-template>

<ng-template #userItemTemplate let-option>
    @if(option.data) {
    <app-user-name-display [user]="option.data" variant="avatar-name" size="sm" />
    } @else {
    <span class="text-sm font-medium">{{ option.label }}</span>
    }
</ng-template>

<ng-template #alertUserCellRef let-row="$implicit">
    <div class="flex flex-col gap-0.5 min-w-0">
        <app-user-name-display [user]="row.user" variant="avatar-name" size="sm" />
    </div>
</ng-template>

<ng-template #alertModeCellRef let-row="$implicit">
    @if(row.type === 'ASK') {
    <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium bg-arena-orange-100">
        <app-icon type="zap" source="lucide" size="sm" />
        Ask
    </span>
    } @else {
    <span class="inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium bg-arena-blue-100">
        <app-icon [type]="CREDITS_SVG.AGENT_MODE" source="svg" size="sm" />
        Agent
    </span>
    }
</ng-template>

<ng-template #alertUsageCellRef let-row="$implicit">
    <div class="flex flex-col gap-1">
        <div class="flex items-center justify-between text-xs gap-4">
            <span class="text-surface-500">{{ row.consumed | number:'1.0-0' }} / {{ row.allocated | number:'1.0-0'
                }}</span>
            <span class="font-semibold flex-shrink-0" [class.text-red-600]="row.status === 'negative'"
                [class.text-orange-600]="row.status === 'blocked'" [class.text-amber-600]="row.status === 'near-limit'">
                {{ row.pct }}%
            </span>
        </div>
        <div class="h-1.5 bg-gray-100 rounded-full overflow-hidden">
            <div class="h-full rounded-full transition-all" [class.bg-red-500]="row.status === 'negative'"
                [class.bg-orange-500]="row.status === 'blocked'" [class.bg-amber-400]="row.status === 'near-limit'"
                [style.width.%]="row.status === 'negative' ? 100 : row.pct"></div>
        </div>
    </div>
</ng-template>

<ng-template #overviewCard let-card="card">
    <div class="bg-surface-0 rounded-base shadow-md border overflow-hidden flex flex-col">
        <!-- <div class="h-1" [ngClass]="card.borderColor"></div> -->
        <div class="p-4 flex flex-col gap-1 flex-1">
            <span class="text-xs text-surface-400  tracking-wide">{{ card.title }}</span>
            <div class="flex items-end justify-between gap-1 mt-0.5">
                <span class="text-2xl font-bold" [ngClass]="card.valueColor">
                    {{ card.value | number:'1.0-0' }}{{ card.suffix || '' }}
                </span>
                @if(card.secondaryValue !== undefined) {
                <div class="flex items-baseline gap-1">
                    <span class="text-lg text-surface-400 font-medium">/ {{ card.secondaryValue | number:'1.0-0'
                        }}</span>
                </div>
                }
                <!-- @else {
                <span class="text-sm font-semibold" [ngClass]="card.percentColor">{{ card.percentage }}%</span>
                }  -->
            </div>
            <span class="text-xs text-surface-400">{{ card.subtitle }}</span>
            <div class="h-1.5 bg-gray-100 rounded-full mt-2 overflow-hidden">
                <div class="h-full rounded-full transition-all" [ngClass]="card.barColor"
                    [style.width.%]="card.barPercentage || card.percentage"></div>
            </div>
        </div>
    </div>
</ng-template>